module.exports = __webpack_public_path__ + "static/media/logo-awi.d230726d.svg";